
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import PasswordResetForm from './PasswordResetForm';

interface AuthTabsProps {
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  isResetMode: boolean;
  setIsResetMode: (isResetMode: boolean) => void;
  sendMagicLink: (e: React.FormEvent) => Promise<void>;
}

const AuthTabs = ({
  email,
  setEmail,
  password,
  setPassword,
  loading,
  setLoading,
  isResetMode,
  setIsResetMode,
  sendMagicLink
}: AuthTabsProps) => {
  return (
    <Tabs defaultValue="login" className="space-y-4">
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="login">Login</TabsTrigger>
        <TabsTrigger value="register">Register</TabsTrigger>
      </TabsList>
      
      <TabsContent value="login" className="space-y-4">
        <LoginForm 
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          loading={loading}
          setLoading={setLoading}
          setIsResetMode={setIsResetMode}
          sendMagicLink={sendMagicLink}
        />
      </TabsContent>
      
      <TabsContent value="register" className="space-y-4">
        <RegisterForm 
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          loading={loading}
          setLoading={setLoading}
        />
      </TabsContent>

      {isResetMode && (
        <PasswordResetForm
          email={email}
          setEmail={setEmail}
          setIsResetMode={setIsResetMode}
          loading={loading}
          setLoading={setLoading}
        />
      )}
    </Tabs>
  );
};

export default AuthTabs;
